import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Service } from '../shared/services/service';
import { Funcoes } from "../funcoes";

@Injectable()
export class TipoTransporteService extends Service {

  constructor(
    protected http: Http,
    protected func: Funcoes
  ) {
    super();
    this.url = this.dominio + '/adm/tipo-transporte/';
  }

}



// WEBPACK FOOTER //
// ./src/app/laudos-cd/tipo-transporte.service.ts